import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  return (
    <section id="why-choose" style={{ marginTop: '5%' }}>
    <h2 style={{ fontFamily: "'Times New Roman', Times, serif" }}>Why Choose Us?</h2>
    <div className="choose-container">
      {/* Item 1 */}
      <div className="choose-item">
        <img src="https://cdn-icons-png.flaticon.com/512/1828/1828970.png" alt="Satisfaction Icon" />
        <h4 style={{ fontFamily: "'Times New Roman', Times, serif" }}>Voices of Satisfaction</h4>
        <p style={{ fontFamily: "'Times New Roman', Times, serif" }}>Partnering with Sawla Stones was the best decision! Their stone quality and exceptional service exceeded all our expectations.</p>
      </div>

      {/* Item 2 */}
      <div className="choose-item">
        <img src="https://cdn-icons-png.flaticon.com/512/1828/1828979.png" alt="Quality Icon" />
        <h4 style={{ fontFamily: "'Times New Roman', Times, serif" }}>Unwavering Quality</h4>
        <p style={{ fontFamily: "'Times New Roman', Times, serif" }}>For 29 years, we've built our legacy on trust and quality. Every stone is carefully inspected to ensure you receive only the best.</p>
      </div>

      {/* Item 3 */}
      <div className="choose-item">
        <img src="https://cdn-icons-png.flaticon.com/512/2082/2082040.png" alt="Competitive Edge" />
        <h4 style={{ fontFamily: "'Times New Roman', Times, serif" }}>Competitive Edge</h4>
        <p style={{ fontFamily: "'Times New Roman', Times, serif" }}>We ensure top-quality stones at prices that offer you the best value for your investment.</p>
      </div>

      {/* Item 4 */}
      <div className="choose-item">
        <img src="https://cdn-icons-png.flaticon.com/512/3135/3135706.png" alt="Innovation Icon" />
        <h4 style={{ fontFamily: "'Times New Roman', Times, serif" }}>Innovative at Heart</h4>
        <p style={{ fontFamily: "'Times New Roman', Times, serif" }}>We’re always evolving. By using the latest stone processing technology, we make sure our products stay a step ahead.</p>
      </div>
    </div>
  </section>
  );
}

export default WhyUs;
